module.exports = __webpack_public_path__ + "static/media/portfolio-5.d0876ba5.jpg";